import React from "react";

const Manifesto = () => (
  <section className="manifesto" aria-labelledby="manifesto-title">
    <div className="wrap">
      <div className="manifesto-header">
        <span className="section-num">04</span>
        <h2 className="section-title" id="manifesto-title">
          How we <em>approach learning</em>.
        </h2>
      </div>
      <div className="manifesto-grid">
        <article className="manifesto-card">
          <div className="step-num">RULE 01</div>
          <div className="icon">
            <svg viewBox="0 0 48 48">
              <use href="#mc-fun" />
            </svg>
          </div>
          <h3>Learning should be enjoyable.</h3>
          <p>
            If it isn't, something's broken. Usually the teaching, not the brain
            receiving it.
          </p>
        </article>

        <article className="manifesto-card">
          <div className="step-num">RULE 02</div>
          <div className="icon">
            <svg viewBox="0 0 48 48">
              <use href="#mc-story" />
            </svg>
          </div>
          <h3>Stories beat bullet points.</h3>
          <p>
            The brain commits things to long-term memory by wrapping them in a
            story. So we write lessons, not slide decks.
          </p>
        </article>

        <article className="manifesto-card">
          <div className="step-num">RULE 03</div>
          <div className="icon">
            <svg viewBox="0 0 48 48">
              <use href="#mc-bite" />
            </svg>
          </div>
          <h3>Long courses, bite-sized chunks.</h3>
          <p>
            Proper depth takes proper time. But life comes in 15-minute windows,
            so we build for those.
          </p>
        </article>

        <article className="manifesto-card">
          <div className="step-num">RULE 04</div>
          <div className="icon">
            <svg viewBox="0 0 48 48">
              <use href="#mc-ai" />
            </svg>
          </div>
          <h3>Personalised to you.</h3>
          <p>
            Our AI quietly rewrites every course around your role, location and
            goals. <strong>The examples become yours.</strong>
          </p>
        </article>

        <article className="manifesto-card">
          <div className="step-num">RULE 05</div>
          <div className="icon">
            <svg viewBox="0 0 48 48">
              <use href="#mc-human" />
            </svg>
          </div>
          <h3>Humans mark your work.</h3>
          <p>
            Real people read what you wrote and write back. We love a friendly
            human touch.
          </p>
        </article>

        <article className="manifesto-card">
          <div className="step-num">RULE 06</div>
          <div className="icon">
            <svg viewBox="0 0 48 48">
              <use href="#mc-school" />
            </svg>
          </div>
          <h3>Taught by people doing the job.</h3>
          <p>
            Our tutors are still in the game. Practitioners, founders, the
            occasional professor who still gets their hands dirty. You learn the
            secret sauce from people using these skills on a Tuesday morning,
            not the theory from a textbook.
          </p>
        </article>
      </div>
    </div>
  </section>
);

export default Manifesto;
